import React, { Fragment } from "react";
import SideModal from "components/SideModal";
import { useFormattedMessage } from "hooks";
import { sendFormError } from "i18n/messages/errors";
import TwoCellRow from "components/TwoCellRow";
import { Player } from "@lottiefiles/react-lottie-player";
import successIcon from "assets/images/success-icon.json";
import NewLoader from "components/NewLoader";

const messages = {
    sendFormError,
    confirmation: "confirmation_project",
    confirmationSuccess: "confirmation_success",
};

const ConfirmationSideModal = ({
    open,
    onConfirm = () => {},
    onCloseButtonClick = () => {},
    heading,
    question,
    confirmBtnText = "Confirm",
    cancelBtnText = "Cancel",
    propForConfirm,
    isConfirming,
    requestError,
    confirmationList,
    failedList,
    succeedList,
    errorList,
    isShowListRight = false,
    successMessage = "",
}) => {
    const { formatMessage } = useFormattedMessage();
    return (
        <SideModal
            className="confirmation-modal"
            open={open}
            onCloseButtonClick={() => onCloseButtonClick()}
            containerClassName="mw-100 px-5 pt-10"
            heading={
                heading || (succeedList && Object.entries(succeedList).length > 0)
                    ? formatMessage(messages.confirmationSuccess)
                    : formatMessage(messages.confirmation)
            }
        >
            {succeedList && Object.entries(succeedList).length > 0 ? (
                <div>
                    <Player
                        autoplay
                        loop={false}
                        keepLastFrame
                        speed={1}
                        src={successIcon}
                        style={{ width: 94, marginTop: 60 }}
                    />
                    {successMessage && <h5 className="text-center">{successMessage}</h5>}
                </div>
            ) : (
                <>
                    <h4 className="mw-400 text-left mt-0">{question}</h4>
                    {!propForConfirm &&
                        Array.isArray(confirmationList) &&
                        confirmationList?.map((item, index) => {
                            return (
                                <TwoCellRow
                                    key={index}
                                    lClassname={"text-16 fw-500 text-left"}
                                    containerClassname="w-90 mt-4"
                                    left={item.name}
                                    right={isShowListRight ? item.id : null}
                                />
                            );
                        })}
                    {requestError ? (
                        <span className="error pl-0 mb-0 d-block mw-100">{formatMessage(messages["sendFormError"])}</span>
                    ) : (
                        <>
                            {failedList?.length > 0 && (
                                <>
                                    <h4 className="text-left alert-red-color ">Confirmation Failed</h4>
                                    {failedList?.map((item, index) => (
                                        <span
                                            key={index}
                                            className={`pl-0 d-block mw-100  ${index === item.length - 1 ? "mb-4" : "mb-2"}`}
                                        >{`${confirmationList.find((_item) => _item.id == item)?.name || ""}`}</span>
                                    ))}
                                </>
                            )}
                            {errorList &&
                                Object.entries(errorList)?.map((item, index) => {
                                    return (
                                        <Fragment key={`error-${index}`}>
                                            <h4
                                                className={`text-left alert-red-color ${
                                                    !confirmationList || confirmationList?.length == 0
                                                        ? "text-16 fw-500 text-left error pl-0 mw-100"
                                                        : ""
                                                }`}
                                            >
                                                {item[0]}
                                            </h4>
                                            {confirmationList?.length > 0 &&
                                                item?.[1]?.map((item, errorIndex) => (
                                                    <TwoCellRow
                                                        key={errorIndex}
                                                        lClassname={"text-16 fw-500 text-left"}
                                                        rClassname={"text-16 fw-600"}
                                                        containerClassname="w-90 mt-2"
                                                        left={confirmationList.find((_item) => _item.id == item)?.name || ""}
                                                        right={item}
                                                    />
                                                ))}
                                        </Fragment>
                                    );
                                })}
                        </>
                    )}

                    {failedList?.length > 0 ? null : (
                        <div className="delete-modal-buttons mt-10">
                            <button
                                disabled={isConfirming}
                                onClick={() => onConfirm(propForConfirm ? propForConfirm : null)}
                                className="text-16 mb-4 w-100 confirmation-btn"
                            >
                                {isConfirming ? <NewLoader className="confirmation-loader" /> : confirmBtnText}
                            </button>
                            <button
                                onClick={onCloseButtonClick}
                                disabled={isConfirming}
                                className={`text-16 mb-4 secondary w-100 ${isConfirming ? "disable-grey" : ""}`}
                            >
                                {cancelBtnText}
                            </button>
                        </div>
                    )}
                </>
            )}
        </SideModal>
    );
};

export default ConfirmationSideModal;
